import React from "react";
import SidebarField from "../../Components/SidebarField";
import EarningDetails from "./Orders/EarningDetails";
import { useSelector } from "react-redux";

const EarningModal = ({ handleClose, isEarningDetail, earningData }) => {
  console.log("earningData", earningData);

  const { theme } = useSelector((state) => state.theme);
  if (isEarningDetail) {
    return (
      <>
        <SidebarField
          footer={false}
          handleClose={() => handleClose()}
          title={`Order Details`}
        >
          <div className="px-2">
            <EarningDetails
              deliveryDetails={earningData?.orderId?.delivery_address}
              vendorDetails={earningData?.orderDetails?.vendor}
              ProductDetails={earningData?.orderDetails}
            />
          </div>
        </SidebarField>
      </>
    );
  }
};

export default EarningModal;
